import unescapedText from 'I18n/utils/unescapedText';
import { Flex } from 'foundations-components/components/Flex';
import { Text } from 'foundations-components/components/Text';
import { useTrellisFocusRing } from 'foundations-components/hooks/useTrellisFocusRing';
import styled from 'styled-components';
import { RemoveIcon } from 'foundations-assets/icons/components/RemoveIcon';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const AIChicletWrapper = styled.div.withConfig({
  displayName: "AIChiclet__AIChicletWrapper",
  componentId: "sc-1ih82d8-0"
})(({
  $focusRingStyles,
  onClick,
  theme
}) => Object.assign({}, $focusRingStyles, {
  alignItems: 'center',
  backgroundColor: theme.color['fill-surface-default'],
  border: `${theme.borderWidth['100']} solid ${theme.color['border-tertiary-default']}`,
  borderRadius: '0.75rem',
  boxShadow: theme.boxShadow[200],
  cursor: onClick ? 'pointer' : 'default',
  display: 'inline-flex',
  paddingTop: theme.space[100],
  paddingRight: theme.space[200],
  paddingBottom: theme.space[100],
  paddingLeft: '6px'
}, onClick && {
  '&:hover': {
    backgroundColor: theme.color['fill-tertiary-hover']
  }
}));
const StyledAIChicletIconWrapper = styled.div.withConfig({
  displayName: "AIChiclet__StyledAIChicletIconWrapper",
  componentId: "sc-1ih82d8-1"
})(["margin-right:6px;display:flex;align-items:center;justify-content:center;"]);
const StyledAIChicletRemoveButton = styled.button.withConfig({
  displayName: "AIChiclet__StyledAIChicletRemoveButton",
  componentId: "sc-1ih82d8-2"
})(({
  $focusRingStyles,
  theme
}) => Object.assign({}, $focusRingStyles, {
  backgroundColor: 'transparent',
  border: 'none',
  borderRadius: theme.borderRadius[100],
  padding: theme.space[0],
  lineHeight: 0,
  cursor: 'pointer'
}));
const AIChiclet = ({
  'data-test-id': dataTestId,
  closeable = false,
  icon: Icon,
  onClick,
  onCloseClick,
  text,
  secondaryIcon
}) => {
  const {
    focusProps: chicletFocusProps,
    focusRingStyles: chicletFocusRingStyles
  } = useTrellisFocusRing();
  const {
    focusProps: removeButtonFocusProps,
    focusRingStyles: removeButtonFocusRingStyles
  } = useTrellisFocusRing();
  return /*#__PURE__*/_jsxs(AIChicletWrapper, Object.assign({}, chicletFocusProps, {
    $focusRingStyles: onClick ? chicletFocusRingStyles : undefined,
    "data-test-id": dataTestId,
    role: "button",
    onClick: onClick,
    children: [/*#__PURE__*/_jsx(StyledAIChicletIconWrapper, {
      children: /*#__PURE__*/_jsx(Icon, {})
    }), /*#__PURE__*/_jsx(Text, {
      as: "span",
      marginInlineEnd: "200",
      typography: "heading-25",
      children: text
    }), secondaryIcon, closeable && /*#__PURE__*/_jsx(Flex, {
      marginInlineEnd: "100",
      onClick: event => {
        event.stopPropagation();
        onCloseClick === null || onCloseClick === void 0 || onCloseClick();
      },
      children: /*#__PURE__*/_jsx(StyledAIChicletRemoveButton, Object.assign({}, removeButtonFocusProps, {
        $focusRingStyles: removeButtonFocusRingStyles,
        "aria-label": unescapedText('aiComponentsUiLibrary.components.chiclet.remove'),
        type: "button",
        children: /*#__PURE__*/_jsx(RemoveIcon, {
          color: "icon-core-subtle"
        })
      }))
    })]
  }));
};
export default AIChiclet;